import { PropsWithChildren } from "react";
import clsx from "clsx";

type InsightListItemVisualProps = PropsWithChildren<{
  icon: JSX.Element;
  tabName?: string;
  title: string;
  print?: boolean;
}>;

export const InsightListItemVisual = ({ icon, tabName, title, children, print }: InsightListItemVisualProps) => {
  const quickInsightCols = localStorage.getItem("quickInsightCols") === "true";
  return (
    <div className="w-full">
      <div
        className={clsx(
          "flex px-2 py-2 md:pl-3 md:pr-4 md:py-3 gap-x-4 flex-1 items-center justify-between outline-hidden max-w-full overflow-hidden",
          !print && "hover:group-data-[state=closed]:bg-platform-blue-50"
        )}
      >
        <div
          className={clsx(
            "hidden md:flex",
            "shrink-0 grow-0 items-center justify-center w-10 h-10 border border-blue-grey-200 rounded-lg overflow-hidden"
          )}
        >
          {icon}
        </div>
        <div className={clsx("grow flex justify-between max-w-full", quickInsightCols ? "flex-col" : "flex-row")}>
          <div className="flex flex-col items-start overflow-hidden grow">
            {tabName && (
              <span className="rounded-sm text-xs font-medium bg-blue-grey-200 text-[rgba(0,9,21,0.5)] px-1 truncate">
                {tabName}
              </span>
            )}
            <h1
              className={clsx(
                "text-blue-grey-950 font-normal text-sm truncate max-w-full py-1 md:py-0",
                !quickInsightCols && "md:text-base"
              )}
            >
              {title}
            </h1>
          </div>
          {/* right aligned elements */}
          {children}
        </div>
      </div>
    </div>
  );
};
